const PURCHASES_URL = '/purchase';

export const getAllPurchases = () => {
  const url = `${PURCHASES_URL}`;
  return url;
};
